import { Component, Inject, OnInit } from '@angular/core';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { CommonService, FeatureFlagService, Shared } from '@rubii/frontend-common';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from '../../../../app/services/config.service';
import { DatasourceConnectionComponent } from '../../datasource-connection/datasource-connection.component';
import { ClientService } from '../../../services/client.service';
import { HttpException } from '@rubii/share/src/classes';
import { featureXero, xeroEvents } from '../../../constants/features';

@Component({
  selector: 'app-xero',
  templateUrl: './xero.component.html',
  styleUrls: ['./xero.component.scss']
})
export class XeroComponent extends BaseDatasourceComponent implements OnInit {
  tenants: any[] = [];
  selectedTenantIds: FormControl;
  loading = false;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { dataSourceId: number, tenants?: any[] }, 
    private client: ClientService, 
    private config: ConfigService, 
    private feature: FeatureFlagService,
    private snackBar: MatSnackBar, 
    private dialogRef: MatDialogRef<DatasourceConnectionComponent>
  ) {
    super();
  }

  ngOnInit() {
    this.selectedTenantIds = new FormControl([], [Validators.required]);
    this.feature.trigger(featureXero, xeroEvents.SelectTenants, {});
    // If tenants are passed in data, we're returning from OAuth
    if (this.data.tenants) {
      this.tenants = this.data.tenants;
      this.loading = false;
    }
  }

  connect() {
    this.loading = true;
    this.client.account.saveXeroTenants(this.selectedTenantIds.value)
      .then(() => {
        this.feature.trigger(featureXero, xeroEvents.Connected, {tenantIds: this.selectedTenantIds.value});
        this.loading = false;
        this.openSnackBar(this.snackBar, 'Xero connected successfully.', 'closed'); 
        this.dialogRef.close({dataSourceId: this.data.dataSourceId});
      })
      .catch(e => {
        this.loading = false;
        this.openSnackBarWarning(this.snackBar, (e as HttpException).message, 'closed');
      });
  }
}